import React from "react";
import useStyles from "./styles/successstory";
import { withTranslation } from "../../i18n";

const storyImg = (src, w, hasSmall = true) => ({ src, w, hasSmall });
const CARD_LIST = [
    { after: storyImg("/static/new-landing-page/success-story/1b.webp", 316), before: storyImg("/static/new-landing-page/success-story/1a.webp", 316) },
    { after: storyImg("/static/new-landing-page/success-story/2b.webp", 316), before: storyImg("/static/new-landing-page/success-story/2a.webp", 316) },
    { after: storyImg("/static/new-landing-page/success-story/3b.webp", 316), before: storyImg("/static/new-landing-page/success-story/3a.webp", 316) },
    { after: storyImg("/static/new-landing-page/success-story/fem_1b.webp", 372), before: storyImg("/static/new-landing-page/success-story/fem_1a.webp", 372) },
    { after: storyImg("/static/new-landing-page/success-story/fem_2b.webp", 316), before: storyImg("/static/new-landing-page/success-story/fem_2a.webp", 372) },
    { after: storyImg("/static/new-landing-page/success-story/fem_3b.webp", 316), before: storyImg("/static/new-landing-page/success-story/fem_3a.webp", 372) },
]
const CARD_SIZES = "(min-width: 1280px) 158px, 110px";
const cardSrcSet = ({ src, w, hasSmall }) =>
    hasSmall ? `${src.replace(".webp", "_220w.webp")} 220w, ${src} ${w}w` : undefined;

const SuccessStory = ({ titleStyle = '', t }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span role="heading" aria-level={2} className={titleStyle}>{t('success-stories-title')}</span>
            <div className={classes.scrollContainer}>
                <div className={classes.scrollContent}>
                    {/* First set of cards */}
                    {CARD_LIST.map((card, index) => (
                        <div className={classes.card} key={`first-${index}`}>
                            <img src={card.before.src} srcSet={cardSrcSet(card.before)} sizes={CARD_SIZES} alt="before" loading="lazy" />
                            <img src={card.after.src} srcSet={cardSrcSet(card.after)} sizes={CARD_SIZES} alt="after" loading="lazy" />
                        </div>
                    ))}
                    {/* Second set of cards for seamless loop */}
                    {CARD_LIST.map((card, index) => (
                        <div className={classes.card} key={`second-${index}`}>
                            <img src={card.before.src} srcSet={cardSrcSet(card.before)} sizes={CARD_SIZES} alt="before" loading="lazy" />
                            <img src={card.after.src} srcSet={cardSrcSet(card.after)} sizes={CARD_SIZES} alt="after" loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default withTranslation(['myfitsociety'])(SuccessStory);